import { FC } from "react"
import Card from "../components/Card"
import { formatDateHour } from "../helpers/date"

type Props = {
  timestamp: string
  title: string
  description: string
  className?: string
}

const LiveNotificationCard: FC<Props> = ({
  timestamp,
  title,
  description,
  className
}) => {
  return (
    <>
      <Card
        className={className}
      >
        <div className="flex-1 flex flex-col">
          <h3 className="text-xl font-bold">{title}</h3>

          <p className="flex-1 italic pt-2 pb-4">{description}</p>

          <div className="pt-4 border-t text-sm uppercase">{formatDateHour(timestamp)}</div>
        </div>
      </Card>
    </>
  )
}

export default LiveNotificationCard